import { createSlice } from "@reduxjs/toolkit";
import { projectDetailsInit } from "../../../types/initStore/initProject";

const initialState = {
    loadingModal: false,
    selectProject: "",
    projectDetails: projectDetailsInit,
    errorGetDetailProject: false,
    selecModalDetails: { active: true, type: "", props: {} },
};

export const isProjectSlice = createSlice({
    name: "project",
    // estado inicial definido en la parte superior line:3
    initialState,
    // todas las acciones que puden modificar el store
    reducers: {
        setLoadingModal: (state, { payload }) => {
            state.loadingModal = payload;
        },
        setSelectProject: (state, { payload }) => {
            state.selectProject = payload.selectProject;
        },
        setProjectDetails: (state, { payload }) => {
            state.projectDetails = payload;
            state.errorGetDetailProject = false;
        },
        setSelecModalDetails: (state, { payload }) => {
            state.selecModalDetails = payload;
        },
        setErrorGetDetailProject: (state, { payload }) => {
            state.errorGetDetailProject = payload;
        },
    },
});

export const { setLoadingModal, setProjectDetails, setSelecModalDetails, setSelectProject, setErrorGetDetailProject } = isProjectSlice.actions;
